import { render } from "./consultationGg.vue?vue&type=template&id=a4dcbcb8&scoped=true"
import script from "./consultationGg.vue?vue&type=script&lang=js"
export * from "./consultationGg.vue?vue&type=script&lang=js"

import "./consultationGg.vue?vue&type=style&index=0&id=a4dcbcb8&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4dcbcb8"]])

export default __exports__